import { render, staticRenderFns } from "./option-panel-show.vue?vue&type=template&id=02450185&scoped=true&"
import script from "./option-panel-show.vue?vue&type=script&lang=js&"
export * from "./option-panel-show.vue?vue&type=script&lang=js&"
import style0 from "./option-panel-show.vue?vue&type=style&index=0&id=02450185&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02450185",
  null
  
)

export default component.exports